var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("base-snackbar", {
        attrs: { errors: _vm.feedingProgramDetailPostErrors },
        on: {
          "update:errors": function($event) {
            _vm.feedingProgramDetailPostErrors = $event
          }
        }
      }),
      _c(
        "v-row",
        [
          _c(
            "v-col",
            { attrs: { cols: "12" } },
            [
              _c("v-text-field", {
                attrs: {
                  label: "Day",
                  type: "number",
                  disabled: _vm.editMode,
                  "error-messages": _vm.errors.day
                },
                model: {
                  value: _vm.day,
                  callback: function($$v) {
                    _vm.day = $$v
                  },
                  expression: "day"
                }
              })
            ],
            1
          ),
          _c(
            "v-col",
            { attrs: { cols: "12" } },
            [
              _c("v-text-field", {
                attrs: {
                  label: "Feed Per Day (Kg)",
                  type: "number",
                  "error-messages": _vm.errors.feedPerDayKg
                },
                model: {
                  value: _vm.feedPerDayKg,
                  callback: function($$v) {
                    _vm.feedPerDayKg = $$v
                  },
                  expression: "feedPerDayKg"
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _c(
        "v-btn",
        {
          staticClass: "mr-2 mt-2",
          attrs: {
            color: "primary",
            dark: "",
            dense: "",
            small: "",
            loading: _vm.feedingProgramDetailPosting
          },
          on: { click: _vm.sendFeedingProgramDetailRequest }
        },
        [_c("span", [_vm._v("Save")])]
      ),
      _vm.editMode
        ? _c(
            "v-btn",
            {
              staticClass: "mt-2",
              attrs: { color: "error", dark: "", dense: "", small: "" },
              on: { click: _vm.cancelEditMode }
            },
            [_c("span", [_vm._v("Cancel")])]
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }